import React from "react";
import './SiteDetails.css'
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

function SiteDetails({link,image,siteName,description}) {
  return (
    <div className="">
      <div>
        <div className="site__details">
          
            <img src={image} alt="" />
          
          <div className="site__name__desc">
            <a href={link} target="_blank">
              <h4>{siteName}</h4>
            </a>
            <p>{description}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SiteDetails;
